import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import LiveMatchesSection from './components/LiveMatchesSection';
import HotBettingSection from './components/HotBettingSection';
import StatsSection from './components/StatsSection';
import NewsSection from './components/NewsSection';
import CTASection from './components/CTASection';
import PartnersSection from './components/PartnersSection';
import HomeSchema from './components/HomeSchema';
import { Helmet } from './components/Helmet';

export default function Home() {
  return (
    <>
      <Helmet
        title="米乐体育官方平台-专业体育赛事直播与竞猜"
        description="米乐体育是专业的体育综合服务平台，提供足球、篮球、网球等热门赛事直播、数据分析与竞猜服务。米乐体育汇聚全球顶级联赛资源，为体育爱好者带来极致观赛体验与互动乐趣，立即注册享专属福利。"
        keywords="米乐体育,米乐体育官网,米乐体育平台,米乐体育直播,米乐体育app下载,米乐体育赛事竞猜,米乐体育注册登录"
        canonical="https://www.milesports.com"
      />
      <HomeSchema />
      <Navbar />
      <main>
        <HeroSection />
        <LiveMatchesSection />
        <HotBettingSection />
        <StatsSection />
        <NewsSection />
        <CTASection />
        <PartnersSection />
      </main>
      <Footer />
    </>
  );
}